import { render, staticRenderFns } from "./RelTermoRespoBemMovel.vue?vue&type=template&id=52dd5914&"
import script from "./RelTermoRespoBemMovel.vue?vue&type=script&lang=js&"
export * from "./RelTermoRespoBemMovel.vue?vue&type=script&lang=js&"
import style0 from "./RelTermoRespoBemMovel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports